// eslint-disable-next-line no-unused-vars
import React, { useMemo } from 'react';
import { Dropdown, DropdownButton, ButtonGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './Filter.scss';

const Filter = ({ items, selectedItem, handleUpdate, icon }) => {
    const processedItems = useMemo(() => items.map((currentItem) => {
        return <Dropdown.Item
            key={currentItem.key}
            eventKey={currentItem.key}
            onClick={() => handleUpdate(items.find((service) => service.key === currentItem.key))}
            className={selectedItem.label === currentItem.label ? 'dropdownItem selectedItem' : 'dropdownItem'}
        >
            {currentItem.label}
        </Dropdown.Item>;
    }), [selectedItem]);

    return <DropdownButton
        as={ButtonGroup}
        title={<span className='currentSelection'><i className={`icon ${icon}`}/>{selectedItem.label}</span>}
        className='customFilter'
    >
        {processedItems}
    </DropdownButton>;
};

Filter.propTypes = {
    selectedItem: PropTypes.object,
    handleUpdate: PropTypes.func,
    items: PropTypes.array.isRequired,
    icon: PropTypes.string
};

export default Filter;
